/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.CancelInteracMoneyResponse,
  CancelInteracMoneyRequest: (params: vp.CancelInteracMoneyRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostCancelInteracBulkPayout: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldCancelInteracMoneyRequest, setShouldCancelInteracMoneyRequest] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.CancelInteracMoneyRequest>({
    TransactionID: '',
  });
  const [response, setResponse] = useState<vp.CancelInteracMoneyResponse>({
    Success: false,
    ErrorMessage: '',
    TransactionID: '',
    TransactionStatus: '',
    Timestamp: '',
  });

  useEffect(() => {
    if (!shouldCancelInteracMoneyRequest) return () => {};

    const PostCancelInteracBulkPayout = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');
      const res = await api.postCancelInteracBulkPayout(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldCancelInteracMoneyRequest) void PostCancelInteracBulkPayout();
    setShouldCancelInteracMoneyRequest(false);
    return () => {
      source.cancel();
    };
  }, [shouldCancelInteracMoneyRequest]);

  return [
    response,
    (_params: vp.CancelInteracMoneyRequest) => {
      setParams(_params);
      setShouldCancelInteracMoneyRequest(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        TransactionID: '',
        TransactionStatus: '',
        Timestamp: '',
      });
      setShouldCancelInteracMoneyRequest(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostCancelInteracBulkPayout);
